import { Instagram, Linkedin, Twitter } from "lucide-react";

const LINKS = [
  { label: "Manifesto", href: "#manifesto", testid: "footer-link-manifesto" },
  { label: "Plans", href: "#plans", testid: "footer-link-plans" },
  { label: "Contact", href: "#contact", testid: "footer-link-contact" },
  { label: "Open App", href: "https://dualcare4u.com", testid: "footer-link-app", external: true },
];

const SOCIALS = [
  { icon: Twitter, testid: "footer-social-twitter" },
  { icon: Instagram, testid: "footer-social-instagram" },
  { icon: Linkedin, testid: "footer-social-linkedin" },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-paper" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
        <p className="font-serif font-semibold tracking-tight leading-none text-[16vw] sm:text-[11vw] text-paper/95 select-none" data-testid="footer-wordmark">
          DUAL&nbsp;CARE
        </p>
        <div className="mt-12 flex flex-col md:flex-row md:items-end justify-between gap-10 border-t border-paper/15 pt-10">
          <div className="max-w-sm">
            <p className="text-sm text-paper/60 leading-relaxed">
              The visitation tracker partnering parents and social workers — one goal: more
              bonding time between children and the people who love them. Not legal advice.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.testid}
                  href="#top"
                  data-testid={s.testid}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-paper/20 text-paper/70 transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-10 gap-y-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="text-sm text-paper/70 transition-colors duration-300 hover:text-paper"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-3 border-t border-paper/15 pt-6 text-xs font-mono text-paper/40">
          <span>© 2026 Dual Care Application. All rights reserved.</span>
          <span>Made with care, for families finding their rhythm.</span>
        </div>
      </div>
    </footer>
  );
}
